export default __webpack_public_path__ + "static/1866-760ef3da38dafd8b8323b2a4a57be54f.gif";